import React from 'react'
import { dataFooter } from '../../data/data-footer'
import './footer.scss'
import img from '../../assets/images/footer/bg.png'

const Footer = (props) => {
  const { isMobile } = props
  return (
    <div className='footerNP'>
      <footer className='footerNP-app'>
        <div className='footerNP-app-link'>
          {
            dataFooter.map((value, idx) => (
              <a key={idx} href={value.link} target="_blank" rel="noreferrer">
                {value?.title}
              </a>
            ))
          }
        </div>
        <div className='footerNP-app-hotline'>
          <img src={img} alt="image" />
          <a className='footerNP-app-hotline-text' href="tel:1800 6111">
            <p>
              Hotline miễn phí:
            </p>
            <p>
              1800 6111
            </p>
          </a>
        </div>
        {
          isMobile ? (
            <><div className='footerNP-app-copyright'>
              Copyright © 2021 Nippon Paint.

            </div>
              <div className='footerNP-app-copyright'>
                All Rights Reserved
              </div>
            </>
          ) : <div className='footerNP-app-copyright'>
            Copyright © 2021 Nippon Paint.<p>&nbsp;All Rights Reserved </p>
          </div>
        }

      </footer>
    </div>
  )

}

export default Footer
